<template>
  <!-- Modern Footer -->
  <footer class="modern-footer">
    <div class="footer-container">
      <div class="footer-grid footer-grid-4col">
        <!-- Company Info & Contact Details - Left Side -->
        <div class="footer-section company-contact-section bordered-section">
          <div class="company-logo">
            <img src="/images/aslan-energy-logo-hq.jpg" alt="Aslan Energy Logo" class="footer-logo" />
            <h3 class="company-name">Aslan Energy</h3>
          </div>
          <p class="company-description">
            {{ locale === 'tr' ? 'Yenilenebilir enerji alanında uzman kadromuz ve modern teknolojimizle sürdürülebilir çözümler sunuyoruz.' : 'We provide sustainable solutions with our expert team and modern technology in renewable energy.' }}
          </p>
          
          <!-- Contact Information -->
          <h4 class="section-title">{{ locale === 'tr' ? 'Telefon Numaralarımız' : 'Our Phone Numbers' }}</h4>
          <div class="simple-contact-item">
            <span class="contact-name">Mustafa Aslan</span>
            <a href="tel:+905321729992" class="contact-phone">+90 532 172 99 92</a>
          </div>
          <div class="simple-contact-item">
            <span class="contact-name">Taha Koray Aslan</span>
            <a href="tel:+905307709644" class="contact-phone">+90 530 770 96 44</a>
          </div>

          <h4 class="section-title" style="margin-top: 25px;">{{ locale === 'tr' ? 'Email Adreslerimiz' : 'Our Email Addresses' }}</h4>
          <div class="simple-contact-item">
            <span class="contact-name">İletişim Maili</span>
            <a href="mailto:aslanmadencilik44@gmail.com" class="contact-email">aslanmadencilik44@gmail.com</a>
          </div>
          <div class="simple-contact-item">
            <span class="contact-name">Destek Maili</span>
            <a href="mailto:info@aslanenergy.com.tr" class="contact-email">info@aslanenergy.com.tr</a>
          </div>
          <div class="simple-contact-item">
            <span class="contact-name">Muhasebe İletişim</span>
            <a href="mailto:muhasebe@aslanenergy.com.tr" class="contact-email">muhasebe@aslanenergy.com.tr</a>
          </div>

          <h4 class="section-title" style="margin-top: 25px;">{{ locale === 'tr' ? 'Sosyal Medya Hesaplarımız' : 'Our Social Media Accounts' }}</h4>
          <div class="social-media-grid">
            <a href="https://www.instagram.com/aslanenergy/" class="social-media-link" target="_blank">
              <i class="fab fa-instagram"></i>
              <span>Instagram</span>
            </a>
            <a href="https://www.facebook.com/p/Aslan-Energy-100054519006747/" class="social-media-link" target="_blank">
              <i class="fab fa-facebook"></i>
              <span>Facebook</span>
            </a>
            <a href="https://www.linkedin.com/company/aslan-energy-madenci%CC%87li%CC%87k-san-ve-ti%CC%87c-ltd-%C5%9Fti%CC%87" class="social-media-link" target="_blank">
              <i class="fab fa-linkedin"></i>
              <span>LinkedIn</span>
            </a>
            <a href="https://www.youtube.com/@aslanenergy" class="social-media-link" target="_blank">
              <i class="fab fa-youtube"></i>
              <span>YouTube</span>
            </a>
          </div>
        </div>

        <!-- Contact Form - Center -->
        <div class="footer-section contact-form-section bordered-section">
          <h4 class="section-title">{{ locale === 'tr' ? 'İletişim Formu' : 'Contact Form' }}</h4>
          <p class="form-description">
            {{ locale === 'tr' ? 'Projeleriniz için bizimle iletişime geçin.' : 'Get in touch with us for your projects.' }}
          </p>
          <!-- Success Message -->
          <div v-if="showSuccessMessage" class="success-message">
            <div class="success-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="success-text">
              <h5>{{ locale === 'tr' ? 'Başarılı!' : 'Success!' }}</h5>
              <p>{{ locale === 'tr' ? 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.' : 'Your message has been sent successfully. We will get back to you soon.' }}</p>
            </div>
          </div>

          <form class="footer-contact-form" @submit.prevent="submitForm" v-show="!showSuccessMessage">
            <div class="form-group">
              <input 
                type="text" 
                v-model="form.first_name" 
                :placeholder="locale === 'tr' ? 'Ad' : 'First Name'"
                class="footer-input"
                required
              />
            </div>
            <div class="form-group">
              <input 
                type="text" 
                v-model="form.last_name" 
                :placeholder="locale === 'tr' ? 'Soyad' : 'Last Name'"
                class="footer-input"
                required
              />
            </div>
            <div class="form-group">
              <input 
                type="email" 
                v-model="form.email" 
                :placeholder="locale === 'tr' ? 'E-posta' : 'Email'"
                class="footer-input"
                required
              />
            </div>
            <div class="form-group phone-group">
              <div class="phone-wrapper">
                <span class="phone-prefix">+90</span>
                <input 
                  type="tel" 
                  v-model="form.phone" 
                  placeholder="5** *** ** **"
                  class="footer-input phone-input"
                  pattern="[0-9]{10}"
                  maxlength="10"
                  @input="validatePhone"
                />
              </div>
            </div>
            <div class="form-group">
              <select v-model="form.subject" class="footer-select" required>
                <option value="">{{ locale === 'tr' ? 'Konu Seçin' : 'Select Subject' }}</option>
                <option value="quote">{{ locale === 'tr' ? 'Teklif Talebi' : 'Quote Request' }}</option>
                <option value="info">{{ locale === 'tr' ? 'Bilgi Almak' : 'Information' }}</option>
                <option value="support">{{ locale === 'tr' ? 'Teknik Destek' : 'Technical Support' }}</option>
                <option value="partnership">{{ locale === 'tr' ? 'İş Ortaklığı' : 'Partnership' }}</option>
                <option value="other">{{ locale === 'tr' ? 'Diğer' : 'Other' }}</option>
              </select>
            </div>
            <div class="form-group">
              <textarea 
                v-model="form.message" 
                :placeholder="locale === 'tr' ? 'Mesajınız' : 'Your Message'"
                class="footer-textarea"
                rows="3"
                required
              ></textarea>
            </div>
            <button type="submit" class="footer-submit-btn" :disabled="isSubmitting">
              <span v-if="!isSubmitting">
                <i class="fas fa-paper-plane"></i>
                {{ locale === 'tr' ? 'Gönder' : 'Send' }}
              </span>
              <span v-else>
                <i class="fas fa-spinner fa-spin"></i>
                {{ locale === 'tr' ? 'Gönderiliyor...' : 'Sending...' }}
              </span>
            </button>
          </form>
        </div>

        <!-- Branches Section -->
        <div class="footer-section branches-section bordered-section">
          <h4 class="section-title">{{ locale === 'tr' ? 'Şubelerimiz' : 'Our Branches' }}</h4>
          
          <!-- Istanbul Branch -->
          <div class="branch-item">
            <span class="branch-title">{{ locale === 'tr' ? 'İstanbul Şubesi' : 'Istanbul Branch' }}</span>
            <span class="branch-address">Ataköy 7-8-9-10. Kısım Mahallesi, E-5 Yan Yol, No: 6, 34156 Bakırköy/İstanbul</span>
            <div class="map-container" style="margin-top: 10px; margin-bottom: 15px;">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3012.584268658442!2d28.90573761551601!3d40.99215547929973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa7040068086b%3A0x8d9c5b3a2f1e4d6c!2sE-5%20Yan%20Yol%20No%3A6%2C%20Atak%C3%B6y%2C%2034156%20Bak%C4%B1rk%C3%B6y%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1729890987654!5m2!1str!2str"
                width="100%" 
                height="150" 
                style="border:0; border-radius: 6px;" 
                allowfullscreen="" 
                loading="lazy" 
                referrerpolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </div>
          
          <!-- Malatya Branch -->
          <div class="branch-item">
            <span class="branch-title">{{ locale === 'tr' ? 'Malatya Şubesi' : 'Malatya Branch' }}</span>
            <span class="branch-address">Arı Sok, Karaoğlan Apt, Üçbağlar, Sivas Cd. No:4/a, 44200 Battalgazi/Malatya</span>
            <div class="map-container" style="margin-top: 10px;">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3065.8267933384174!2d38.31993461551928!3d38.35837197929042!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c9a8b8f5c4d6e2%3A0x8e7f2a9b6c5d4e3f!2s%C3%9C%C3%A7ba%C4%9Flar%2C%20Sivas%20Cd.%20No%3A4%2FA%2C%2044200%20Battalgazi%2FMalatya!5e0!3m2!1str!2str!4v1729890654321!5m2!1str!2str"
                width="100%" 
                height="150" 
                style="border:0; border-radius: 6px;" 
                allowfullscreen="" 
                loading="lazy" 
                referrerpolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </div>
        </div>

        <!-- Quick Links - Right Side -->
        <div class="footer-section quick-links bordered-section">
          <h4 class="section-title">{{ locale === 'tr' ? 'Hızlı Linkler' : 'Quick Links' }}</h4>
          <ul class="footer-links">
            <li><a href="#hero">{{ locale === 'tr' ? 'Ana Sayfa' : 'Home' }}</a></li>
            <li><a href="#about">{{ locale === 'tr' ? 'Hakkımızda' : 'About Us' }}</a></li>
            <li><a href="#services">{{ locale === 'tr' ? 'Hizmetlerimiz' : 'Services' }}</a></li>
            <li><a href="#projects">{{ locale === 'tr' ? 'Projelerimiz' : 'Projects' }}</a></li>
            <li><a href="#stats">{{ locale === 'tr' ? 'İstatistikler' : 'Statistics' }}</a></li>
          </ul>
        </div>
      </div>

      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p class="copyright">
            © 2025 <strong>Aslan Energy</strong>. {{ locale === 'tr' ? 'Tüm hakları saklıdır.' : 'All rights reserved.' }}
          </p>
          <div class="footer-bottom-links">
            <a href="#">{{ locale === 'tr' ? 'Gizlilik Politikası' : 'Privacy Policy' }}</a>
            <a href="#">{{ locale === 'tr' ? 'Kullanım Şartları' : 'Terms of Service' }}</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useContact } from '@/composables/useContact'

// Props
defineProps({
  locale: {
    type: String,
    default: 'tr'
  }
})

// Composable kullanımı
const { 
  form, 
  isSubmitting, 
  showSuccessMessage,
  submitForm, 
  validatePhone 
} = useContact()
</script>